<template>
  <section class="wrapper">
    <van-form @submit="save">
      <van-field
        is-link
        input-align="right"
        v-model="applyInfo.Process.text"
        label="流程名称"
        readonly
        placeholder="请选择"
        :rules="[{ required: true, message: '请先选择流程名称' }]"
        @click="showProcessPicker=true"
      />
      <van-field
        input-align="right"
        v-model="applyInfo.ActApply"
        label="申请人"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入' }]"
        clearable
      >
        <template #button>
          <van-button block type="info" native-type="button" class="van-field_dosth" @click="showAgencyPicker=true">代办</van-button>
        </template>
      </van-field>
      <van-field
        is-link
        input-align="right"
        v-model="applyInfo.Post.text"
        label="发起岗位"
        readonly
        placeholder="请选择"
        :rules="[{ required: true, message: '请设置用户岗位' }]"
        @click="showPostPicker=true"
      />
      <van-field
        input-align="right"
        v-model="applyInfo.summary"
        rows="1"
        autosize
        label="摘要"
        type="textarea"
      />
      <van-field class="mt10" input-align="right" label="流程内容">
        <template #input>
          <van-uploader v-model="applyInfo.uploader" :after-read="(file)=>{
                  //自行上传文件
                  applyInfo.uploader.forEach((item, index) => {
                    //此时可以自行将文件上传至服务器
                    fileUpload(applyInfo,item.file).then(response=>{
                      if (response.success) {
                            applyInfo.fileList.push({
                            frGuid: response.frGuid,
                            A_GUID: response.A_GUID,
                            FileName: response.FileName,
                            ImgOcr: response.ImgOcr
                          })
                      }
                      else{
                          $toast.fail('上传失败');
                        }
                    });
                  })
                }" multiple>
            <van-button size="small" icon="plus" round plain type="primary"/>
          </van-uploader>
        </template>
      </van-field>
      <van-collapse v-model="activeNames">
        <div class="van-remove-detail-items" v-for="(detail,index) in applyInfo.details" :key="index">
          <label class="van-remove-detail" v-if="index>0"><i class="iconfont iconfont-guanbi iconfont-style" @click="removeDetails(index)"></i></label>
          <van-collapse-item :title="`自定义明细${index+1}`" :name="index">
            <van-field
              is-link
              class="mt10"
              input-align="right"
              v-model="detail.DDate"
              label="日期"
              readonly
              placeholder="请选择"
              @click="detail.showWindows.showDate=true"
            />
            <van-field
              class="mt10"
              input-align="right"
              v-model="detail.Remark"
              rows="4"
              autosize
              label="描述"
              type="textarea"
            />
            <van-field
              class="mt10"
              input-align="right"
              v-show="isShowFieldOne"
              v-model="detail.Amount"
              label="金额"
              placeholder="请输入"
              type="number"
              @change="(e)=>{
                  detail.Amount=parseFloat(e.target.value).toFixed(2)
                }"
            />
            <van-field class="mt10" input-align="right" label="附件" v-show="isShowFieldTwo">
              <template #input>
                <van-uploader v-model="detail.uploader" :after-read="(file)=>{
                  //自行上传文件
                  detail.uploader.forEach((item, index) => {
                    //此时可以自行将文件上传至服务器
                    fileUpload(detail,item.file).then(response=>{
                      if (response.success) {
                          detail.fileList.push({
                          frGuid: response.frGuid,
                          A_GUID: response.A_GUID,
                          FileName: response.FileName,
                          ImgOcr: response.ImgOcr
                        })
                      }
                      else{
                        $toast.fail('上传失败');
                      }
                    });
                  })
                }" multiple>
                  <van-button size="small" icon="plus" round plain type="primary"/>
                </van-uploader>
              </template>
            </van-field>
            <!--日期-->
            <van-popup v-model="detail.showWindows.showDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="datetime"
                @cancel="detail.showWindows.showDate=false"
                @confirm="()=>{
                  detail.DDate = moment(currentDate).format('YYYY/MM/DD');
                  detail.showWindows.showDate=false
                }"
              />
            </van-popup>
          </van-collapse-item>
        </div>
      </van-collapse>
      <div class="add-detail" @click="addDetails"><i class="iconfont iconfont-zengjia"></i>添加明细</div>
    <div class="pr5 pl5">
      <van-button block type="info">提交</van-button>
    </div>
    </van-form>
    <!--流程名称弹框-->
    <van-popup v-model="showProcessPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="processList"
        @cancel="showProcessPicker = false"
        @confirm="onProcess"
      />
    </van-popup>
    <!--岗位弹框-->
    <van-popup v-model="showPostPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="postList"
        @cancel="showPostPicker = false"
        @confirm="onPost"
      />
    </van-popup>
    <!--代办弹框是否弹出-->
    <van-popup v-model="showAgencyPicker" round position="bottom">
      <div class="agency-title">选择申请人</div>
      <!--如果不设置this.list.length>0这个条件的话，load会一直加载-->
      <van-list v-model="agencyLoading" :finished="finished" :finished-text="finishedText"  @load="LoadAgencyList">
        <div class="agency-box">
          <van-row class="th-row">
            <van-col>部门</van-col>
            <van-col>岗位</van-col>
            <van-col>姓名</van-col>
            <van-col>手机号码</van-col>
            <van-col>Email</van-col>
          </van-row>
          <van-row class="tb-row" v-for="(item, index) of list" :key="index" @click="selectAgencyUser(item, index)">
            <van-col>{{ item.DeptName }}</van-col>
            <van-col>{{ item.PostName }}</van-col>
            <van-col>{{ item.Employee }}</van-col>
            <van-col>{{ item.tel }}</van-col>
            <van-col>{{ item.Email }}</van-col>
          </van-row>
        </div>
      </van-list>
    </van-popup>
  </section>
</template>

<script>
  import {getUserPostListApi,getStaffListNotCurrentApi, getUserPostUserNameApi, submitApplyFormApi} from '@/api/reimbursement'
  import {getDiyProcessListApi,getDiyProcessColsApi,getProcessApprovalUsersApi, fileUploadApi} from '@/api/common'
  export default {
    data() {
      return {
        isShow: true,//是否显示
        isShowFieldOne:false,//是否显示指定字段
        isShowFieldTwo:false,//是否显示指定字段
        showProcessPicker:false,//弹出流程名称弹框
        showPostPicker: false,//弹出岗位弹框
        showAgencyPicker: false,//弹出代办人弹框
        currentDate: new Date(),//当前日期
        applyInfo: {
          GUID:this.guid(),//审批表单GUID
          Post: {text: '', value: ''},//发起岗位
          Process: {text: '', value: ''},//流程名称
          ActApply: '',//申请人
          summary:'',//摘要
          uploader: [],//需要上传的文件
          fileList: [],//存储上传的文件
          details:[{
            GUID: this.guid(),//生成唯一的GUID
            DDate:'',//日期
            Remark: '',//描述
            Amount:'',//金额
            uploader: [],//需要上传的文件
            fileList: [],//存储上传的文件
            //弹框对象
            showWindows: {
              showDate:false,
            },
          }],
        },
        processList: [
          {text: "", value: ""}
        ],//流程列表
        postList: [
          {text: "", value: ""}
        ],//岗位列表
        activeNames: [0],//请假明细分组名称
        list: [],//代办人列表数据
        agencyLoading: false, // 加载状态
        finished: false, // 是否加载
        finishedText: '',
        pages: 0, // 页数
        pagesize: 10, // 条数
      }
    },
    mounted() {
      this.getDiyProcessList();
      this.getUserPostList();
    },
    methods:{
      //加载分页数据
      LoadAgencyList() {
        this.pages += 1; // 页数+1
        this.getStaffListNotCurrent();
      },
      //获取职工人员列表
      async getStaffListNotCurrent() {
        this.finishedText='';
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getStaffListNotCurrentApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.agencyLoading = false
            if(response.result.length>0){
              this.list = this.list.concat(response.result) // 追加数据
              this.finished = false;
              //这里暂时不需要分页所以将每页条数和总条数保持一致即可
              this.pagesize=this.list.length;
              // 如果当前页数 = 总页数，则已经没有数据
              if (this.pages === Math.ceil(this.list.length / this.pagesize)) {
                this.finished = true
                this.finishedText = '- 没有更多了-'
              }
              return;
            }
            this.finished = true
            this.finishedText = '-暂无数据-'
            return;
          }
          this.finished = true
          this.finishedText = '- 数据异常-'
          return;
        }
      },
      //选择申请人信息
      selectAgencyUser(item,index){
        this.postList=[];
        let data = new Object();
        data.text = item.PostName;
        data.value = item.PostsetGUID;
        this.postList.push(data);
        this.applyInfo.Post.text = item.PostName;
        this.applyInfo.Post.value = item.PostsetGUID;
        this.applyInfo.ActApply=item.Employee;
        this.showAgencyPicker=false;
      },
      //获取启用自定义流程列表
      async getDiyProcessList() {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId
        };
        let response = await getDiyProcessListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              let data = new Object();
              data.text = item.ProcessName;
              data.value = item.Process;
              arr.push(data);
            });
            if(arr!=undefined&&arr!=null&&arr.length>0) {
              this.processList = arr;
              this.applyInfo.Process.text = arr[0].text;
              this.applyInfo.Process.value = arr[0].value;
              this.getDiyProcessCols(this.applyInfo.Process.value);
            }
          }
        }
      },
      //获取启用模板流程字段
      async getDiyProcessCols(process) {
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          process: process
        };
        let response = await getDiyProcessColsApi(params);
        if (response.success) {
          if (response.code === "0000") {
            response.result.forEach((item,index)=>{
              if(item.FieldName==="FAmount"){
                this.isShowFieldOne=true;
              }
              else if (item.FieldName === "FAttachment") {
                this.isShowFieldTwo=true;
              }
            });
          }
        }
      },
      //选择启用流程
      onProcess(item) {
        this.applyInfo.Process.value = item.value;
        this.applyInfo.Process.text = item.text;
        this.getDiyProcessCols(this.applyInfo.Process.text);
        this.showProcessPicker = false;
      },
      //获取用户岗位列表
      async getUserPostList() {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID
        };
        let response = await getUserPostListApi(params);
        if (response.success) {
          if (response.code === "0000") {
            let arr = new Array();
            response.result.forEach(function (item, index) {
              let data = new Object();
              data.text = item.PostName;
              data.value = item.GUID;
              arr.push(data);
            });
            if(arr!=undefined&&arr!=null&&arr.length>0) {
              this.postList = arr;
              this.applyInfo.Post.text = arr[0].text;
              this.applyInfo.Post.value = arr[0].value;
              this.getUserPostUserName(this.applyInfo.Post.value);
            }
          }
        }
      },
      //选择岗位
      onPost(item) {
        this.applyInfo.Post.value = item.value;
        this.applyInfo.Post.text = item.text;
        this.getUserPostUserName(this.applyInfo.Post.value);
        this.showPostPicker = false;
      },
      //获取岗位人员名称
      async getUserPostUserName(postGuid) {
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let params = {
          cGuid: companyInfo.companyId,
          uGuid: userInfo.U_GUID,
          postGuid: postGuid
        };
        let response = await getUserPostUserNameApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.applyInfo.ActApply = response.result;
          }
        }
      },
      //上传至服务器
      async fileUpload(detail,file) {
        //此时可以自行将文件上传至服务器
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let formData = new FormData();
        formData.append("cGuid", companyInfo.companyId);
        formData.append("uGuid", userInfo.U_GUID);
        formData.append("frGuid", detail.GUID);
        formData.append("TempFileNameFirst", "1");
        formData.append("Type", "OCR");
        formData.append("sequence", detail.GUID);
        formData.append("RelationType", "FW");
        formData.append("scanType", "");
        formData.append("categoryGuid", "74FD3D28-B288-465A-9059-4A267D030878");
        formData.append("isTemp", "true");
        formData.append("file", file);
        return await fileUploadApi(formData);
      },
      //增加自定义明细
      addDetails() {
        this.applyInfo.details.push({
          GUID: this.guid(),//生成唯一的GUID
          DDate: '',//开始时间
          Remark: '',//描述
          Amount:'',//金额
          uploader: [],//需要上传的文件
          fileList: [],//存储上传的文件
          //弹框对象
          showWindows: {
            showDate:false,
          },
        })
      },
      //移除报销明细
      removeDetails(index){
        this.applyInfo.details.splice(index,1);
      },
      //提交表单
      async save() {
        this.isShow = false;
        let formValue=this.applyInfo.Process.value;
        if(formValue==undefined||formValue==null||formValue=="") {
          this.$toast.fail("请先选择流程名称");
          return;
        }
        let postGuid = this.applyInfo.Post.value;
        if(postGuid==undefined||postGuid==null||postGuid=="") {
          this.$toast.fail("请先设置岗位");
          return;
        }
        let actApply = this.applyInfo.ActApply;
        let approvalGuid = this.applyInfo.GUID;
        let userInfo = this.getCookie("UserInfo");
        let companyInfo = this.getCookie("CompanyInfo");
        let paylist = new Array();
        this.applyInfo.details.forEach((v, i) => {
          let approvalDetailGuid = v.GUID;
          let date = v.DDate;
          let remark = v.Remark;
          let amount = v.Amount;
          let pay = new Object;
          pay.Approval_GUID = approvalGuid;
          pay.Approval_Sub_GUID = approvalDetailGuid;
          pay.FormType = this.applyInfo.Process.text;
          pay.BeginDate = date;
          pay.Remark = remark;
          pay.Post_GUID = postGuid;
          pay.SumLeave = amount;
          pay.C_GUID = companyInfo.companyId;
          paylist.push(pay);
        });
        let approvalFormInfo = new Object;
        approvalFormInfo.Approval_GUID = approvalGuid;
        approvalFormInfo.FormType = this.applyInfo.Process.text;
        approvalFormInfo.Post_GUID = postGuid;
        approvalFormInfo.ActApply = actApply;
        approvalFormInfo.Remark = this.applyInfo.summary;
        approvalFormInfo.C_GUID = companyInfo.companyId;
        approvalFormInfo.U_GUID = userInfo.U_GUID;
        approvalFormInfo.Creator = userInfo.NickName;
        approvalFormInfo.CompanyName = companyInfo.companyName;
        approvalFormInfo.UserName = userInfo.TelName || userInfo.LoginName;
        approvalFormInfo.ApplyName = userInfo.NickName || (userInfo.FirstName+userInfo.LastName);
        approvalFormInfo.detailFLLists = paylist;
        let params = {
          ...approvalFormInfo
        };
        let response = await submitApplyFormApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.isShow = true;
            this.$router.push({path: "/follow"})
            return;
          }
          this.$toast.fail(response.msg);
          return;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    height: calc(100vh - 5rem);
    ::v-deep.van-hairline--top-bottom{
      .van-remove-detail-items {
        position: relative;
        height: 100%;
        .van-remove-detail {
          display: flex;
          position: absolute;
          right: 3rem;
          z-index: 5;
          text-align: center;
          align-items: center;
          padding: 10px 16px;
          line-height: 24px;
          color: #0066ff;
          font-size: 1.4rem;
          .iconfont-style{
            font-size:1.1rem;
          }
        }
      }
    }
    .add-detail {
      color: #0066ff;
      text-align: center;
      padding: 1rem 0;
      font-size: 1.4rem;
    }
    ::v-deep.van-field__error-message{
      text-align: right;
    }
    ::v-deep.van-collapse-item__content {
      padding: 0;
    }

    ::v-deep.van-collapse-item__title {
      background: #f6f6f8;
    }
    .van-field_dosth{
      height: 100%;
    }
    .van-popup{
      height: 40%;
    }
    .user-card {
      display: inline-flex;
      padding: 5px;
      color: black;
      font-size: 1.6rem;
      background: #f3f3f3;
      flex-direction: row;
      align-items: center;
      margin-top: 1rem;
      vertical-align: middle;
      margin-right: 1rem;

      &-profile {
        width: 3.5rem;
        height: 3.5rem;
      }
    }
    .agency-title {
      padding: 2rem 0;
      font-size: 1.8rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 2rem;
      text-align: center;
    }

    .agency-box {
      margin: 1.2rem 0;
      .th-row {
        height: 5.6rem;
        line-height: 5.6rem;
        background: #ebf1f7;
        padding: 0px 1.2rem;
      }
      .tb-row {
        height: 5.6rem;
        line-height: 5.6rem;
        padding: 0px 1.2rem;
        display: flex;
        justify-content: space-between !important;
      }
      .van-col{
        width:20%;
        text-align: center;
        font-size: 1.6rem;
      }
    }
    ::v-deep {
      .my-popup.van-popup--bottom.van-popup--round {
        border-radius: 10px 10px 0 0;
      }
    }
  }
</style>
